import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseTakeItem;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { fromJS } from 'immutable';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Button } from '@instructure/ui-buttons';
import { IconCalculatorLine, IconMoveUpTopLine } from '@instructure/ui-icons';
import { CustomPropTypes, LearnosityCalculator, Pin, PositionBox, Response, componentForItem, featureOn, onPhone, toErrors } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/format-message';
import { COMPONENT_TAKE, PARENT_TYPE_QUIZ_SESSION, TAKE_CHAR_LIMIT, withStyleOverrides, FormFieldGroup } from '@instructure/quiz-common';
import { KEYSTROKE_ENTRY_TYPES } from '@instructure/quiz-interactions';
import { Tooltip } from '@instructure/ui-tooltip';
import generateStyle from './styles';
import generateComponentTheme from './theme';
var BaseTakeItem = /*#__PURE__*/function (_Component) {
  function BaseTakeItem() {
    var _this2;
    _classCallCheck(this, BaseTakeItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BaseTakeItem, [].concat(args));
    _defineProperty(_this2, "state", {
      previousInteractionSlug: null,
      previewResponseCallback: null
    });
    _defineProperty(_this2, "_editResponse", function (resp, properties, invalid) {
      return _this2.props.editResponse(_this2.props.sessionItem, resp, properties, invalid);
    });
    _defineProperty(_this2, "_debouncedEditResponse", debounce(_this2._editResponse, 2500, {
      leading: false,
      maxWait: 5000,
      trailing: true
    }));
    _defineProperty(_this2, "handleResponseUpdate", function (resp, properties) {
      var invalid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (_this2.props.timeIsUp) {
        _this2.props.addError(t('Time is up. Answer not saved.'));
      } else if (resp == null || JSON.stringify(resp).length < TAKE_CHAR_LIMIT) {
        // Update in the UI
        _this2.state.previewResponseCallback(_this2.props.sessionItem, resp, properties, invalid);
        // Send back to kinesis
        _this2._debouncedEditResponse(resp, properties, invalid);
      }
    });
    _defineProperty(_this2, "getError", function (field) {
      var errors = _this2.getResponse().getErrors().toJS();
      return toErrors(errors[field] || []);
    });
    _defineProperty(_this2, "pinWithScreenreaderMessage", function () {
      var confirmationMessage = _this2.props.isPinned ? t('Question unpinned') : t('Question pinned');
      return _this2.props.pinSessionItem(_this2.props.quizSessionId, _this2.props.position).then(function () {
        return _this2.props.screenreaderNotification(confirmationMessage);
      });
    });
    _defineProperty(_this2, "propsForInteraction", function () {
      var _this2$props = _this2.props,
        allowClearMcSelection = _this2$props.allowClearMcSelection,
        appContainer = _this2$props.appContainer,
        choiceElimination = _this2$props.choiceElimination,
        displayValidationWarning = _this2$props.displayValidationWarning,
        item = _this2$props.item,
        interactionFileUpload = _this2$props.interactionFileUpload,
        openImportModal = _this2$props.openImportModal,
        quizSessionId = _this2$props.quizSessionId,
        screenreaderNotification = _this2$props.screenreaderNotification,
        sessionItem = _this2$props.sessionItem,
        lockDown = _this2$props.lockDown,
        disableDocumentAccess = _this2$props.disableDocumentAccess,
        separatorConfig = _this2$props.separatorConfig;
      var simpleItem = item.toJS();
      var userResponse = _this2.getResponse().userResponse;
      var simpleUserResponse = userResponse && userResponse.toJS();
      var onUploadError = function onUploadError() {
        _this2.props.addError(t('Your upload failed. Please try again.'));
      };
      var mediaUpload = function mediaUpload(id, file, callback) {
        interactionFileUpload(PARENT_TYPE_QUIZ_SESSION, quizSessionId, file, callback, onUploadError);
      };
      return {
        // TODO - implement cancelMediaUpload
        allowClearMcSelection: allowClearMcSelection,
        appContainer: appContainer,
        choiceElimination: choiceElimination,
        displayValidationWarning: displayValidationWarning,
        handleResponseUpdate: _this2.handleResponseUpdate,
        interactionData: simpleItem.interactionData,
        itemBody: simpleItem.itemBody,
        itemId: sessionItem.id,
        mediaUpload: mediaUpload,
        notifyScreenreader: screenreaderNotification,
        openImportModal: openImportModal,
        properties: simpleItem.properties,
        scoringData: simpleItem.scoringData,
        userResponse: simpleUserResponse || {},
        lockDown: lockDown,
        multipleHotSpotEnabled: featureOn('multiple_hotspot_selections'),
        disableDocumentAccess: disableDocumentAccess,
        separatorConfig: separatorConfig
      };
    });
    return _this2;
  }
  _inherits(BaseTakeItem, _Component);
  return _createClass(BaseTakeItem, [{
    key: "getInteractionType",
    value: function getInteractionType() {
      return this.props.item.getInteractionType();
    }
  }, {
    key: "getResponse",
    value: function getResponse() {
      var _this$props = this.props,
        response = _this$props.response,
        item = _this$props.item;
      if (response) {
        return Response.create(response);
      }
      var defaultResponse = fromJS({
        userResponse: this.getInteractionType().getDefaultUserResponse(item.interactionData.toJS())
      });
      return Response.create(defaultResponse);
    }
  }, {
    key: "getPointsText",
    value: function getPointsText() {
      return t("{\n      points, plural,\n        one {# point}\n      other {# points}\n    }", {
        points: this.props.pointsPossible
      });
    }
  }, {
    key: "renderJumpToInfoButton",
    value: function renderJumpToInfoButton() {
      if (this.props.scrollToInfo && onPhone()) {
        return jsx(Button, {
          onClick: this.props.scrollToInfo,
          renderIcon: IconMoveUpTopLine
        }, jsx(ScreenReaderContent, null, t('View Stimulus')));
      }
    }
  }, {
    key: "renderCalculator",
    value: function renderCalculator() {
      var _this$props2 = this.props,
        activeCalculatorId = _this$props2.activeCalculatorId,
        quizSessionId = _this$props2.quizSessionId,
        sessionItem = _this$props2.sessionItem,
        setActiveCalculatorId = _this$props2.setActiveCalculatorId;
      var calculatorType = sessionItem.get('calculatorType');
      return calculatorType !== 'none' && jsx(LearnosityCalculator, {
        activeCalculatorId: activeCalculatorId,
        setActiveCalculatorId: setActiveCalculatorId,
        calculatorType: calculatorType,
        quizSessionId: quizSessionId,
        render: this.renderCalculatorTrigger
      });
    }
  }, {
    key: "renderCalculatorTrigger",
    value: function renderCalculatorTrigger(_ref) {
      var toggleCalculator = _ref.toggleCalculator,
        enabled = _ref.enabled;
      return jsx(Tooltip, {
        renderTip: t('This calculator has accessibility limitations.')
      }, jsx(Button, {
        renderIcon: IconCalculatorLine,
        size: "small",
        onClick: toggleCalculator,
        disabled: !enabled
      }, jsx(ScreenReaderContent, null, t('Calculator. Use the arrow keys to move the calculator after selecting Move. Screen readers may not announce the launch clearly.'))));
    }
  }, {
    key: "renderPin",
    value: function renderPin() {
      return jsx(Pin, {
        isPinned: this.props.isPinned,
        pinSessionItem: this.pinWithScreenreaderMessage,
        position: this.props.position
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._debouncedEditResponse.flush();
      if (this.state.previewResponseCallback && this.state.previewResponseCallback.flush) {
        this.state.previewResponseCallback.flush();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Interaction = componentForItem(this.getInteractionType().slug, COMPONENT_TAKE);
      var positionText = t('Question at position {position, number}', {
        position: this.props.questionNumber
      });
      var screenreaderWhiteSpace = jsx(ScreenReaderContent, null, "\xA0");
      return jsx("div", {
        className: "wrapper",
        css: this.props.styles.wrapper,
        tabIndex: "-1"
      }, jsx("div", {
        css: this.props.styles.questionSpacer
      }, jsx("div", {
        css: this.props.styles.questionSpacerLine
      })), jsx("div", {
        css: this.props.styles.question,
        "data-automation": "sdk-take-item-question"
      }, jsx("div", {
        css: this.props.styles.header
      }, jsx("section", {
        css: this.props.styles.headerSection
      }, jsx(PositionBox, {
        position: this.props.questionNumber,
        headingText: positionText,
        headingLevel: this.props.isInStimulus ? 'h3' : 'h2'
      }), screenreaderWhiteSpace, jsx("div", {
        css: this.props.styles.infoHeader
      }, jsx("div", {
        className: "interactionType",
        css: this.props.styles.infoHeaderItem
      }, this.getInteractionType().translatedName, screenreaderWhiteSpace), jsx("div", {
        className: "points",
        css: this.props.styles.infoHeaderItem
      }, this.getPointsText(), screenreaderWhiteSpace)), this.renderCalculator(), jsx("div", {
        css: this.props.styles.pin
      }, this.props.showPin && this.renderPin(), screenreaderWhiteSpace), jsx("div", {
        css: this.props.styles.jumpToInfo
      }, this.renderJumpToInfoButton(), screenreaderWhiteSpace))), jsx("div", {
        css: this.props.styles.contentWrapper
      }, jsx(FormFieldGroup, {
        messages: this.getError('userResponse'),
        description: jsx(ScreenReaderContent, null, positionText, "\xA0")
      }, jsx("div", {
        css: this.props.styles.interactionWrapper
      }, jsx(Interaction, this.propsForInteraction()))))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Using derived state to avoid doing a comparison on every keystroke or store change
      // If this becomes a problem, debounce can be moved down to interaction take components
      var interactionTypeSlug = props.item.getInteractionType().slug;
      if (interactionTypeSlug !== state.previousInteractionSlug) {
        var isKeystrokeEntryType = KEYSTROKE_ENTRY_TYPES.includes(interactionTypeSlug);
        var previewResponse = isKeystrokeEntryType ? debounce(props.previewResponse, 300, {
          leading: true,
          trailing: true
        }) : props.previewResponse;
        return {
          previewResponseCallback: previewResponse,
          previousInteractionSlug: interactionTypeSlug
        };
      }
      return null;
    }
  }]);
}(Component);
_BaseTakeItem = BaseTakeItem;
_defineProperty(BaseTakeItem, "displayName", 'TakeItem');
_defineProperty(BaseTakeItem, "componentId", "Quizzes".concat(_BaseTakeItem.displayName));
_defineProperty(BaseTakeItem, "propTypes", {
  activeCalculatorId: PropTypes.string,
  addError: PropTypes.func.isRequired,
  allowClearMcSelection: PropTypes.bool,
  appContainer: CustomPropTypes.selectors.isRequired,
  choiceElimination: PropTypes.bool,
  displayValidationWarning: PropTypes.bool,
  editResponse: PropTypes.func.isRequired,
  interactionFileUpload: PropTypes.func.isRequired,
  isPinned: PropTypes.bool.isRequired,
  item: ImmutablePropTypes.record.isRequired,
  openImportModal: PropTypes.func.isRequired,
  pinSessionItem: PropTypes.func.isRequired,
  pointsPossible: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  questionNumber: PropTypes.number.isRequired,
  previewResponse: PropTypes.func.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  response: ImmutablePropTypes.map,
  screenreaderNotification: PropTypes.func.isRequired,
  scrollToInfo: PropTypes.func,
  setActiveCalculatorId: PropTypes.func,
  sessionItem: ImmutablePropTypes.record.isRequired,
  showPin: PropTypes.bool.isRequired,
  timeIsUp: PropTypes.bool.isRequired,
  lockDown: PropTypes.bool,
  isInStimulus: PropTypes.bool,
  styles: PropTypes.object,
  disableDocumentAccess: PropTypes.bool,
  separatorConfig: PropTypes.shape({
    decimalSeparator: PropTypes.string,
    thousandSeparator: PropTypes.string
  })
});
_defineProperty(BaseTakeItem, "defaultProps", {
  activeCalculatorId: null,
  allowClearMcSelection: false,
  choiceElimination: false,
  displayValidationWarning: false,
  scrollToInfo: null,
  setActiveCalculatorId: Function.prototype,
  lockDown: false,
  response: null,
  isInStimulus: false,
  disableDocumentAccess: false
});
export var TakeItem = withStyleOverrides(generateStyle, generateComponentTheme)(BaseTakeItem);
export default TakeItem;